import groupedByDimension from "./grouped-by-dimension";

export default () => ({
  groupes: Object.keys(groupedByDimension).sort((m1, m2) => {
    const mdl1 = groupedByDimension[m1][0];
    const mdl2 = groupedByDimension[m2][0];
    if (mdl1.row === mdl2.row) {
      return mdl1.col - mdl2.col;
    }
    return mdl1.row - mdl2.row;
  }),
  modeles: groupedByDimension
});
